import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import Mealplan from "../../components/Tab/setUpPages/Mealplan";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import { FaArrowLeft } from "react-icons/fa";

const AddNewMeal = () => {
  const navigate = useNavigate();
  const handleSaveMeal = () => {
    navigate("/profile/meals");
  };
  return (
    <>
      <section className=" max-w-7xl mx-auto px-4 md:px-6 py-10 bg-white rounded-2xl shadow-sm bg-red-50">
        <DecorativeSquares />

        {/* ================= PAGE HEADER ================= */}
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={() => navigate("/profile/meals")}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="text-xl md:text-2xl font-semibold text-gray-900">
            Add New Meal
          </h1>

          <div className="w-10" />
        </div>
        <div className="border p-2 rounded-xl">
          <Mealplan varient="profile" />
        </div>
      </section>
    </>
  );
};

export default AddNewMeal;
